/**
 * ============================================================================
 * ⭐ ONE IN / OUT TAG, EVERYWHERE (2026-09-28, F70)
 * ============================================================================
 *
 * > Pete: *"Why are these outbound and inbound icons different? They should be the
 * > same. use the calendar version of the icons in the driver card."*
 *
 * The calendar chip drew IN light blue and OUT light orange; the driver card drew
 * IN dark slate and OUT indigo. Same word, two looks — a supervisor glancing from
 * the board to the rail had to learn both.
 *
 * ⭐ THE CALENDAR'S LOOK IS THE ONE (Pete's call), and it now lives HERE so the day
 * board, the driver cards and the rail's section headers all render the same
 * component. ⛔ Do not re-inline these classes anywhere: two copies of a colour are
 * how the drift happened in the first place.
 *   ** A SYMBOL DRAWN IN TWO PLACES IS TWO SYMBOLS THE DAY ONE OF THEM IS EDITED. **
 *
 * ⚠️ The week and month boards keep their own 8px `DirBadge` — same colours, a
 * smaller size for their denser cells. Size is theirs to choose; colour is not.
 */
import { cn } from '@/lib/utils';

export type DirectionKind = 'INBOUND' | 'OUTBOUND' | 'BLOCK';

export const DIRECTION_TAG_CLASSES: Record<DirectionKind, string> = {
    INBOUND: 'bg-blue-100 text-blue-800 border-blue-300',
    OUTBOUND: 'bg-orange-100 text-orange-800 border-orange-300',
    BLOCK: 'bg-slate-200 text-slate-700 border-slate-400',
};

export const DIRECTION_TAG_WORD: Record<DirectionKind, string> = {
    INBOUND: 'IN',
    OUTBOUND: 'OUT',
    BLOCK: 'BLK',
};

export function DirectionTag({ direction, className }: { direction: DirectionKind; className?: string }) {
    return (
        <span
            className={cn(
                'inline-block shrink-0 px-1 rounded text-[9px] font-semibold tracking-wide leading-tight border',
                DIRECTION_TAG_CLASSES[direction],
                className,
            )}
        >
            {DIRECTION_TAG_WORD[direction]}
        </span>
    );
}
